import { render, staticRenderFns } from "./company-empty.vue?vue&type=template&id=21040031&scoped=true"
import script from "./company-empty.vue?vue&type=script&lang=js"
export * from "./company-empty.vue?vue&type=script&lang=js"
import style0 from "./company-empty.vue?vue&type=style&index=0&id=21040031&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21040031",
  null
  
)

export default component.exports